import { SendEmail, useSendEmail } from "services/rest/subscription";
import { DateUtils } from "services/utils/DateUtils";
import { AxiosResponse } from "axios";
import { Modal, notification, Typography } from "antd";
import React from "react";
import { useIntl } from "react-intl";
import { ILicenseKey } from "components/license-keys-card/LicenseKyesCard";

export type SendModalProps = {
  licenseKey: ILicenseKey,
  subscriptionId: string,
  visible: boolean,
  onCancel: () => void,
}

export function SendModal(props: SendModalProps) {
  const { licenseKey, subscriptionId, visible, onCancel } = props;
  const intl = useIntl();
  const { loading, fetch } = useSendEmail(subscriptionId, licenseKey.id);


  const onSend = () => {
    fetch()
      .then((resp: AxiosResponse<SendEmail>) => {
        if (resp.data.success) {
          Modal.success({
            title: intl.formatMessage({ id: "jmix-store.send-modal.title" }),
            content: (
              <div>
                {intl.formatMessage(
                  { id: "jmix-store.send-modal.success" },
                  { email: <strong>{licenseKey.email}</strong> },
                )}
              </div>
            ),
            centered: true,
          });
        } else {
          Modal.error({
            title: intl.formatMessage({ id: "jmix-store.send-modal.title" }),
            content: (
              <div>
                <p>
                  {intl.formatMessage(
                    { id: "jmix-store.send-modal.not-sent" },
                    { email: <strong>{licenseKey.email}</strong> },
                  )}
                </p>
                <p>
                  {intl.formatMessage(
                    { id: "jmix-store.send-modal.repeat" },
                    { time: <strong>{DateUtils.getFormatTime(resp.data.repeatIn)}</strong> },
                  )}
                </p>
              </div>
            ),
            centered: true,
          });
        }

        onCancel();
      })
      .catch(() => {
        notification.error({
          message: intl.formatMessage({ id: "jmix-store.send-modal.error" }),
          placement: "bottomLeft",
        });

        onCancel();
      });
  };

  return (
    <Modal
      centered
      title={intl.formatMessage({ id: "jmix-store.send-modal.title" })}
      visible={visible}
      okText={intl.formatMessage({ id: "jmix-store.send-modal.ok-text" })}
      okButtonProps={{
        loading
      }}
      onOk={onSend}
      onCancel={onCancel}
    >
      <Typography>
        <Typography.Paragraph>
          {intl.formatMessage(
            { id: "jmix-store.send-modal.content" },
            { email: <strong>{licenseKey.email}</strong> },
          )}
        </Typography.Paragraph>
      </Typography>
    </Modal>
  );
}
